/* Deviceli: buyback wording that matches how requests are handled (we confirm by email ourselves). Loads after dv-sell-flow.js. */
(function(){
  if (typeof pageSell !== 'function') return;
  var prev = pageSell;
  function swap(h, a, b){ return h.split(a).join(b); }
  window.pageSell = function(){
    var h = prev();
    h = h.replace(/Confirmation sent to ([^\s<]+@[^\s<]+)\.<\/p>/g, 'We will email $1 within one business day to confirm.</p>');
    h = swap(h, 'A prepaid label and a QR code reach you within the hour, by email or text.', 'We email your prepaid label within one business day.');
    h = swap(h, 'Your prepaid label and QR code are on their way.', 'Your request is in.');
    h = swap(h, '>Resend my label<', '>Confirm and request my label<');
    h = swap(h, 'Your label is on its way</h2>', 'Get your free shipping label</h2>');
    h = swap(h, ' No printer? Show the QR code at the counter.', '');
    return h;
  };
  try { if (typeof route === 'function' && typeof DV_VIEW !== 'undefined' && DV_VIEW === 'sell') route(); } catch (e) {}
})();
